<template>
    <section id="__welcome-section">
        <video autoplay loop :src="require('@/../public/videos/Welcome.mp4')" id="__welcome-video" muted></video>
        <section id="__main-content">
<!--            <header class="container d-flex justify-space-between pt-8">-->
<!--                <div>-->
<!--                    <a href="http://tco.am/en">-->
<!--                        <img :src="require('@/../public/images/icons/TCO.png')" alt="tco logo" width="50px"/>-->
<!--                    </a>-->
<!--                </div>-->
<!--                <div id="__menu">-->
<!--                    <ul>-->
<!--                        <template v-if="!AUTHENTICATED">-->
<!--                            <li><router-link :to="{name: 'Login'}">{{$t('auth.login')}}</router-link></li>-->
<!--                            <li><router-link :to="{name: 'Register'}">{{$t('auth.register')}}</router-link></li>-->
<!--                        </template>-->
<!--                        <li v-else><router-link :to="{name: 'Blog'}">{{$t('home.dashboard')}}</router-link></li>-->
<!--                        <v-btn v-if="$i18n.locale === 'am'" @click="setLocale('en')">EN</v-btn>-->
<!--                        <v-btn v-if="$i18n.locale === 'en'" @click="setLocale('am')">AM</v-btn>-->
<!--                    </ul>-->
<!--                </div>-->
<!--            </header>-->

            <section id="__welcome-texts">
                <span id="__welcome-text-types"></span>
            </section>

            <footer class="container">
                <p class="text-xs-left"><a href="http://tco.am" target="_blank">TCO LLC</a> - {{APP_NAME}}</p>
                <p class="text-xs-center">&copy; {{ new Date().getFullYear() }} {{$t('home.rights')}}</p>
                <p class="text-xs-right">
                    <a href="mailto:academy@tco.am" class="ml-3">{{$t('auth.email')}}: academy@tco.am</a>
                </p>
            </footer>

            <ul id="__social-links">
                <v-tooltip left color="green">
                    <template v-slot:activator="{ on }">
                        <li><a v-on="on" href="http://tco.am/en" target="_blank" ><i class="fas fa-link"></i></a></li>
                    </template>
                    <span>TCO - {{$t('home.website')}}</span>
                </v-tooltip>

                <v-tooltip left color="green">
                    <template v-slot:activator="{ on }">
                        <li><a v-on="on" href="http://tco.am/contact" target="_blank"><i class="fas fa-phone" ></i></a></li>
                    </template>
                    <span>{{$t('home.contact')}}</span>
                </v-tooltip>

                <v-tooltip left color="green">
                    <template v-slot:activator="{ on }">
                        <li><a v-on="on" href="https://www.facebook.com/tcoteamllc/" target="_blank"><i class="fab fa-facebook-f" ></i></a></li>
                    </template>
                    <span>Facebook</span>
                </v-tooltip>
            </ul>
        </section>
    </section>
</template>

<script>
    const Typed = require('typed.js');
    export default {
        data(){
          return {
              typing: false,
          }
        },
        mounted() {
            this.runTyping();
        },

        computed: {
            AUTHENTICATED(){
                return localStorage.getItem('home_token') !== null;
            }
        },

        methods: {
            setLocale(locale){
                this.$router.push({ params: { lang: locale } });
                this.typing.destroy();
                this.runTyping();
            },
            runTyping(){
                this.typing = new Typed('#__welcome-text-types', {
                    strings: [`${this.$t('auth.welcome')} ${this.APP_NAME}`, this.$t('home.develop')],
                    typeSpeed: 70,
                    loop: true,
                    showCursor: true,
                    contentType: 'null',
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../scss/pages/Home/index";
</style>